import FaceScan from './FaceScan';

export default FaceScan;
